const pendingBatches = new Map();
let requestSequence = 0;

function flushBatch(batchKey) {
    const batch = pendingBatches.get(batchKey);
    if (!batch) return;
    pendingBatches.delete(batchKey);

    const groups = batch.requests.map((request) => ({
        key: request.key,
        lookupConds: request.lookupConds,
        selectLookups: request.selectLookups,
        freshness: request.freshness,
        cachePolicy: request.cachePolicy,
        isSetting: request.isSetting
    }));

    try {
        batch.api.post(
            `/${batch.routeURL}/search/categories/prepare`,
            { groups },
            (response) => {
                const resultGroups = response && response.data && response.data.groups;
                batch.requests.forEach((request) => request.resolve(resultGroups ? resultGroups[request.key] || null : null));
            },
            batch.postOptions
        );
    } catch (_error) {
        batch.requests.forEach((request) => request.resolve(null));
    }
}

export function enqueueSearchPrepare(api, request, postOptions) {
    return new Promise((resolve) => {
        const routeURL = api.routeURL;
        // The bounded policy is deliberately a single lookup context. Keep
        // duplicate callers isolated here; backend SQL single-flight merges them.
        const batchKey = `${routeURL}|${request.scopeKey || ''}|${request.cachePolicy ? request.cachePolicy + ':' + requestSequence : ''}`;
        let batch = pendingBatches.get(batchKey);
        if (!batch) {
            batch = { api, routeURL, requests: [], postOptions };
            pendingBatches.set(batchKey, batch);
            setTimeout(() => flushBatch(batchKey), 0);
        }

        batch.requests.push({
            key: `request-${++requestSequence}`,
            lookupConds: request.lookupConds || {},
            selectLookups: request.selectLookups || [],
            freshness: request.freshness === 'realtime' ? 'realtime' : 'cached',
            cachePolicy: request.cachePolicy,
            isSetting: Boolean(request.isSetting),
            resolve
        });
    });
}

export function resetSearchPrepareBatcherForTests() {
    pendingBatches.forEach((batch) => batch.requests.forEach((request) => request.resolve(null)));
    pendingBatches.clear();
    requestSequence = 0;
}
